import { SelectAsyncInput } from '@core/components/Select';
import cstApi from 'app/services/api/servicoFiscal/cstApi';
import React from 'react';

const SelectCstSituacaoTributaria = ({ id, name, label, value, touched, error, onBlur, onChange, required = true }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await cstApi.pesquisarCstSituacao({
          size: 100,
          sort: 'codigo',
          page: next,
          q: query,
        });

        const data = response?.data || [];
        return { data };
      }}
      fetchOnFocus
      required={required}
    />
  );
};

export default SelectCstSituacaoTributaria;
